import {
    format,
    isValid,
    parseISO,
    isToday,
    isTomorrow,
    isThisWeek,
    endOfWeek,
    differenceInSeconds,
    endOfDay,
    startOfDay,
} from 'date-fns'

export const DateFormat = {
    localISO: "yyyy-MM-dd'T'HH:mm:ssXXX",
    /** US table date — e.g. 3/30/2026 */
    date: 'M/d/yyyy',
    /** US table date + time — e.g. 3/30/2026 10:08 AM */
    dateTime: 'M/d/yyyy h:mm a',
    MMDDYYYY: 'MM-dd-yyyy',
    mmDD: 'MMMM d',
}

export class DateUtility {
    static dateToLocalISO = (date, formatDate = DateFormat.localISO) => {
        if (!date) {
            return null
        }
        const dateObj = typeof date === 'string' ? parseISO(date) : date
        if (!isValid(dateObj)) {
            return null
        }
        return format(dateObj, formatDate)
    }

    static formatApiDate = date => {
        if (!date) return null
        const dateObj = typeof date === 'string' ? parseISO(date) : date
        if (!isValid(dateObj)) return null
        return format(dateObj, "yyyy-MM-dd'T'00:00:00")
    }

    static parseApiDate = date => {
        if (!date) return new Date()
        if (date instanceof Date) return date
        const parsed = parseISO(date)
        return isValid(parsed) ? parsed : new Date(date)
    }

    static isToday(date) {
        return isToday(date)
    }

    static isTomorrow(date) {
        return isTomorrow(date)
    }

    static isThisWeek(date) {
        return isThisWeek(date)
    }

    static endOfWeek(date) {
        return endOfWeek(date)
    }

    static endDay(date) {
        return endOfDay(date)
    }

    static startDay(date) {
        return startOfDay(date)
    }

    static differenceInSeconds(date1, date2) {
        return differenceInSeconds(date1, date2)
    }
}
